/* Catálogo corporativo NEXOWEAR: buscador, galería, calculadora de tramos, carrito y cotización. */
(function () {
  'use strict';
  var IVA = 0.19;
  var fmt = function (n) { return '$' + Math.round(n).toLocaleString('es-CL'); };
  var norm = function (s) { return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };

  /* ---------- Buscador (índice y categorías) ---------- */
  function initSearch() {
    var input = document.querySelector('[data-nx-search-input]');
    if (!input) return;
    var items = Array.prototype.slice.call(document.querySelectorAll('.nx-root [data-nx-item]'))
      .filter(function (el) { return !el.closest('.nx-related'); });
    var groups = document.querySelectorAll('[data-nx-group]');
    var count = document.querySelector('[data-nx-count]');
    var empty = document.querySelector('[data-nx-empty]');
    var total = items.length;
    items.forEach(function (el) { el._nx = norm(el.getAttribute('data-nx-search')); });
    function run() {
      var q = norm(input.value).trim();
      var words = q ? q.split(/\s+/) : [];
      var shown = 0;
      items.forEach(function (el) {
        var ok = words.every(function (w) { return el._nx.indexOf(w) !== -1; });
        el.hidden = !ok;
        if (ok) shown++;
      });
      groups.forEach(function (g) { g.hidden = !g.querySelector('[data-nx-item]:not([hidden])'); });
      if (count) count.textContent = (q ? shown + ' de ' + total : total) + ' productos';
      if (empty) empty.hidden = shown !== 0;
    }
    input.addEventListener('input', run);
    document.querySelectorAll('[data-nx-jump]').forEach(function (a) {
      a.addEventListener('click', function () { if (input.value) { input.value = ''; run(); } });
    });
  }

  /* ---------- Galería ---------- */
  function initGallery() {
    var g = document.querySelector('[data-nx-gallery]');
    if (!g) return;
    var main = g.querySelector('.nx-gallery__img');
    g.querySelectorAll('[data-nx-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = b.getAttribute('data-nx-thumb');
        main.alt = b.getAttribute('data-alt') || '';
        g.querySelectorAll('.nx-thumb').forEach(function (t) { t.classList.toggle('is-active', t === b); });
      });
    });
  }

  /* ---------- Ficha: tramos, resumen, carrito y cotización ---------- */
  function initPdp() {
    var root = document.querySelector('[data-nx-pdp]');
    if (!root) return;
    var form = root.querySelector('[data-nx-form]');
    var dataEl = document.querySelector('[data-nx-product]');
    var P = dataEl ? JSON.parse(dataEl.textContent) : {};
    var tiers = Array.prototype.map.call(root.querySelectorAll('.nx-tiers--full .nx-tier'), function (li) {
      return { el: li, min: +li.dataset.min, price: +li.dataset.price, variant: +li.dataset.variant, name: li.dataset.name };
    });
    var sizes = Array.prototype.slice.call(form.querySelectorAll('[data-nx-size]'));
    var out = {};
    form.querySelectorAll('[data-nx-o]').forEach(function (el) { out[el.getAttribute('data-nx-o')] = el; });
    var err = form.querySelector('[data-nx-error]');
    var inCart = 0;

    function tierFor(q) {
      var t = tiers[0];
      tiers.forEach(function (x) { if (q >= x.min) t = x; });
      return t;
    }
    function lines() {
      return sizes.map(function (i) { return { talla: i.getAttribute('data-nx-size'), qty: Math.max(0, parseInt(i.value, 10) || 0) }; })
        .filter(function (l) { return l.qty > 0; });
    }
    function color() {
      var r = form.querySelector('input[name="nx-color"]:checked');
      if (r) return r.value;
      var t = form.querySelector('input[name="nx-color-txt"]');
      if (t) return t.value.trim() || 'A confirmar';
      return '';
    }
    function perso() {
      var r = form.querySelector('input[name="nx-perso"]:checked');
      return r ? r.value : '';
    }
    function state() {
      var ls = lines();
      var qty = ls.reduce(function (a, l) { return a + l.qty; }, 0);
      var t = tiers.length ? tierFor(qty + inCart) : null;
      var unit = t ? t.price : 0;
      var net = unit * qty;
      var iva = Math.round(net * IVA);
      return { lines: ls, qty: qty, tier: t, unit: unit, net: net, iva: iva, total: net + iva };
    }
    function render() {
      var s = state();
      out.qty.textContent = s.qty + (s.qty === 1 ? ' unidad' : ' unidades');
      out.tier.textContent = s.qty && s.tier ? s.tier.name : '—';
      out.unit.textContent = s.qty && s.tier ? fmt(s.unit) : '—';
      out.net.textContent = fmt(s.net);
      out.iva.textContent = fmt(s.iva);
      out.total.textContent = fmt(s.total);
      tiers.forEach(function (t) { t.el.classList.toggle('is-active', !!s.qty && t === s.tier); });
      if (inCart > 0) {
        out.incart.hidden = false;
        out.incart.textContent = 'Ya tienes ' + inCart + ' de esta prenda en el carrito: el tramo se calcula con el total (' + (s.qty + inCart) + ').';
      } else out.incart.hidden = true;
      var sum = s.qty + inCart;
      var next = tiers.filter(function (t) { return t.min > sum; })[0];
      if (s.qty && next) {
        var faltan = next.min - sum;
        out.next.hidden = false;
        out.next.textContent = 'Agrega ' + faltan + (faltan === 1 ? ' unidad' : ' unidades') + ' más y pagas ' + fmt(next.price) + ' neto c/u.';
      } else out.next.hidden = true;
      var lbl = form.querySelector('[data-nx-color-label]');
      if (lbl) { var c = form.querySelector('input[name="nx-color"]:checked'); lbl.textContent = c ? '· ' + c.value : ''; }
    }

    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-nx-step]');
      if (!b) return;
      var i = b.parentNode.querySelector('input');
      i.value = Math.max(0, (parseInt(i.value, 10) || 0) + (+b.getAttribute('data-nx-step')));
      render();
    });
    form.addEventListener('input', render);
    form.addEventListener('change', function (e) {
      if (e.target.name === 'nx-perso') {
        var on = !!e.target.value;
        form.querySelector('[data-nx-perso-nota]').hidden = !on;
        form.querySelector('[data-nx-perso-help]').hidden = !on;
      }
      if (e.target.matches('[data-nx-size]') && (parseInt(e.target.value, 10) || 0) < 0) e.target.value = 0;
      render();
    });

    function showError(msg) { err.textContent = msg; err.hidden = !msg; if (msg) err.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
    function validate(needColor) {
      var s = state();
      if (!s.qty) { showError('Indica cuántas unidades necesitas en al menos una talla.'); return null; }
      if (needColor && form.querySelector('input[name="nx-color"]') && !form.querySelector('input[name="nx-color"]:checked')) { showError('Elige un color.'); return null; }
      showError('');
      return s;
    }

    function refreshCartCount() {
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (s) {
          var el = document.getElementById('cart-icon-bubble');
          if (!el || !s['cart-icon-bubble']) return;
          var d = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (d) el.innerHTML = d.innerHTML;
        }).catch(function () {});
    }
    function loadInCart() {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        inCart = c.items.filter(function (i) { return i.product_id === P.id; }).reduce(function (a, i) { return a + i.quantity; }, 0);
        render();
      }).catch(function () {});
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var s = validate(true);
      if (!s || !s.tier) return;
      var btn = form.querySelector('[data-nx-add]');
      var c = color(), p = perso();
      var nota = (form.querySelector('[data-nx-perso-nota]').value || '').trim();
      var items = s.lines.map(function (l) {
        var props = { 'Color': c, 'Talla': l.talla };
        if (p) { props['Personalización'] = p + ' (se cotiza aparte)'; if (nota) props['Detalle del logo'] = nota; }
        return { id: s.tier.variant, quantity: l.qty, properties: props };
      });
      btn.disabled = true; btn.classList.add('is-loading');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'No se pudo agregar'); return j; }); })
        .then(function () { return window.NXCart ? window.NXCart.normalize() : null; })
        .then(function () { return Promise.all([refreshCartCount(), loadInCart()]); })
        .then(function () {
          var ok = form.querySelector('[data-nx-ok]');
          form.querySelector('[data-nx-ok-msg]').textContent = 'Agregaste ' + s.qty + (s.qty === 1 ? ' unidad' : ' unidades') + ' (' + c + '). Tramo en el carrito: ' + tierFor(inCart).name + '.';
          ok.hidden = false;
          sizes.forEach(function (i) { i.value = 0; });
          render();
          ok.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        })
        .catch(function (x) { showError(x.message || 'No se pudo agregar al carrito. Inténtalo otra vez o cotiza por WhatsApp.'); })
        .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
    });
    var okClose = form.querySelector('[data-nx-ok-close]');
    if (okClose) okClose.addEventListener('click', function () { form.querySelector('[data-nx-ok]').hidden = true; });

    function quoteText(s) {
      var c = color(), p = perso();
      var nota = (form.querySelector('[data-nx-perso-nota]').value || '').trim();
      var t = ['Hola NEXOWEAR, quiero cotizar:', '', '• Producto: ' + P.title + (P.ref ? ' (REF ' + P.ref + ')' : '')];
      if (c) t.push('• Color: ' + c);
      t.push('• Tallas: ' + s.lines.map(function (l) { return l.talla + ' × ' + l.qty; }).join(', ') + ' (total ' + s.qty + ')');
      if (s.tier) {
        t.push('• Tramo: ' + s.tier.name + ' · ' + fmt(s.unit) + ' neto c/u');
        t.push('• Subtotal neto: ' + fmt(s.net) + ' · IVA: ' + fmt(s.iva) + ' · Total: ' + fmt(s.total));
      }
      t.push('• Personalización: ' + (p ? p + (nota ? ' — ' + nota : '') : 'no'));
      t.push('', P.url);
      return t.join('\n');
    }
    form.querySelectorAll('[data-nx-quote]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var s = validate(false);
        if (!s) return;
        var txt = quoteText(s);
        if (b.getAttribute('data-nx-quote') === 'mail') {
          location.href = 'mailto:' + (P.mail || '') + '?subject=' + encodeURIComponent('Cotización ' + P.title + (P.ref ? ' REF ' + P.ref : '')) + '&body=' + encodeURIComponent(txt);
        } else {
          window.open('https://wa.me/' + P.wa + '?text=' + encodeURIComponent(txt), '_blank', 'noopener');
        }
      });
    });

    render();
    loadInCart();
  }

  // Barra de categorías (celular): mostrar la categoría actual
  function initSide() {
    var a = document.querySelector('.nx-side__list a.is-active');
    if (!a) return;
    var l = a.closest('.nx-side__list');
    if (l.scrollWidth <= l.clientWidth) return;
    l.scrollLeft += a.getBoundingClientRect().left - l.getBoundingClientRect().left - (l.clientWidth - a.offsetWidth) / 2;
  }

  function init() { initSearch(); initGallery(); initPdp(); initSide(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
